__turbopack_context__.v({
  "link": "Navbar-module__uj6e0q__link",
  "logo": "Navbar-module__uj6e0q__logo",
});
